"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "colledara": {
    "ea97036a": [{
      "hkey": "937aa47c",
      "slug": "colledara",
      "name": "Colledara",
      "primary": true,
      "skipSearch": false
    }],
    "castiglione-della-valle": [{
      "hkey": "937aa47c",
      "slug": "colledara",
      "name": "Colledara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;